module.exports = new __parcel__URL__("janeckova_x1.556391a6.webp").toString();